// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oDC2y","question":"styles_question__3DOPR","description":"styles_description__3u9KG"};